import type { IExtractRouteParamMap } from "../../../types";
import {
  facultyAcademicGroupsRoutesObj,
  facultyAcademicGroupsBreadcrumbs,
} from "../facultyAcademicGroups/path";
import {
  facultyMembersRoutesObj,
  facultyMembersRouteTranslation,
} from "../../usersManagement/facultyMembers/path";

import {
  concatBreadcrumbs,
  createBreadcrumbObject,
  createPaths,
  rebase,
} from "@/routes/utils";

const baseRoute = facultyAcademicGroupsRoutesObj.view;

// * Route configuration object for faculty academic group faculty members-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const facultyAcademicGroupMembersRoutesObj = {
  list: `${baseRoute}${facultyMembersRoutesObj.list}`,
  create: `${baseRoute}${facultyMembersRoutesObj.create}`,
  view: `${baseRoute}${facultyMembersRoutesObj.view}`,
  edit: `${baseRoute}${facultyMembersRoutesObj.edit}`,
} as const;

// * Extracts the route parameters for the faculty route configuration.
export type IFacultyAcademicGroupMembersRouteParams = IExtractRouteParamMap<
  typeof facultyAcademicGroupMembersRoutesObj
>;

// * Path functions for the facultyAcademicGroupFacultyMembers routes.
export const facultyAcademicGroupMembersPath = createPaths<
  typeof facultyAcademicGroupMembersRoutesObj,
  IFacultyAcademicGroupMembersRouteParams
>(facultyAcademicGroupMembersRoutesObj);

// * Breadcrumbs {translation and route} for the faculty routes
const newFacultyAcademicGroupMembersBreadcrumbs = createBreadcrumbObject<
  typeof facultyAcademicGroupMembersRoutesObj
>(facultyAcademicGroupMembersRoutesObj, facultyMembersRouteTranslation);

rebase(newFacultyAcademicGroupMembersBreadcrumbs, "list");

export const facultyAcademicGroupMembersBreadcrumbs = concatBreadcrumbs<
  typeof facultyAcademicGroupMembersRoutesObj
>(
  facultyAcademicGroupsBreadcrumbs.view,
  newFacultyAcademicGroupMembersBreadcrumbs,
);
